<template>
    <div class="row" id="domainDetails">
        <div class="col-md-9">
            <txt id="address" label="Domain" v-model="model.address"></txt>
        </div>
        <div class="col-md-3 domain-extension">
            <list label="Extension" :list="tlds" v-model="model.tld"></list>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            value: { default: '' }
        },
        watch: {
            model: {
                handler: function (val, oldVal) {
                    this.$emit('input', this.model);
                },
                deep: true
            }
        },
        data() {
            return {
                model: {},
                tlds: [ // One line it because you know, pages.
                    'com.au', 'net.au', 'org.au', 'asn.au', 'id.au', 'com', 'au', 'net', 'org', 'asia', 'biz', 'fr', 'info', 'me', 'mobi', 'name', 'co.uk', 'org.uk', 'me.uk', 'co.nz', 'geek.nz', 'gen.nz', 'net.nz', 'org.nz', 'com.tw', 'idv.tw', 'org.tw', 'ac', 'at', 'be', 'bz', 'cc', 'ge', 'edu.ge', 'gs', 'in', 'io', 'la', 'ms', 'nu', 'sh', 'tc', 'tv', 'vg', 'ws', 'co', 'com.co', 'net.co', 'nom.co', 'com.hk', 'pl', 'org.pl', 'net.pl', 'com.pl', 'cymru', 'wales', 'edu.pl', 'eu', 'online'
                ]
            }
        },
        created() {
            this.model = this.value;
        },
        methods: {
            // It's good to clean up event listeners before a component is destroyed.
        },
        beforeDestroy () {
//                this.$eventHub.$off('domainSubmit', this.store);
//                this.$eventHub.$off('setDomain', this.setDomain);
        }
    }
</script>